gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
  ScrollTrigger.matchMedia({
    // Desktop
    "(min-width: 750px)": function () {
      const stickyHeader = document.querySelector("header");
      const anouncementBar = document.querySelector(".announcement-bar-section");
      const trustBadgesSection = document.querySelector(".trust-badges-section");
      const headerHeight = stickyHeader.offsetHeight + anouncementBar.offsetHeight;
      const image = document.querySelector(".trust-badges-section .img-wrap");
      // const sparkle = document.querySelector(".top-border");

      // Create a timeline
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: trustBadgesSection,
          start: `0 ${headerHeight}`,
          end: `bottom ${stickyHeader.offsetHeight}`,
          scrub: true,
          // markers: true,
        },
      });

      // Add animations to the timeline
      timeline.to(image, { 
        y: image.offsetHeight / 1.7, 
        ease: "none" 
      })
      // .to(sparkle, { 
      //   x: "100vw", 
      //   ease: "none" 
      // }, "<");
    },

    // Mobile
    "(max-width: 749px)": function () {
    }
  });
});

